import { AlertProps } from '@mui/material';
import { createSlice } from '@reduxjs/toolkit';

export type toastType = 'info' | 'success' | 'error';
export type maxWidthOptions = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
export type modalBodyType =
  | ''
  | 'closeSession'
  | 'confirmDocumentChange'
  | 'confirmProspectStatus'
  | 'changeProspectSubstate'
  | 'changeTerritoryManager'
  | 'editRepresentativeEmail'
  | 'uploadFile'
  | 'deleteFile'
  | 'dismissProspect'
  | 'aiData';

export type NavigationModel = {
  modalData: {
    id: string;
    open: boolean;
    body: modalBodyType;
    title?: string;
    subtitle?: string;
    maxWidth?: maxWidthOptions;
    onClose?: () => void;
  };
  toastData: {
    open: boolean;
    kind?: AlertProps['severity'];
    text: string;
    autoHide?: boolean;
  };
  loading: boolean;
};

const initialState: NavigationModel = {
  modalData: {
    id: '',
    open: false,
    body: '',
    title: '',
    maxWidth: 'sm',
    onClose: () => '',
  },
  toastData: { open: false, kind: undefined, text: '', autoHide: true },
  loading: false,
};

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    pushNavigation: (state, action: { payload: NavigationModel }) => ({
      ...state,
      ...action.payload,
    }),
    showModal: (
      state,
      action: {
        payload: {
          id?: string;
          body: modalBodyType;
          title: string;
          subtitle?: string;
          maxWidth?: maxWidthOptions;
          onClose?: () => void;
        };
      },
    ) => ({
      ...state,
      modalData: { ...state.modalData, ...action.payload, open: true },
    }),
    hideModal: (state) => ({
      ...state,
      modalData: { ...initialState.modalData, body: state.modalData.body, title: state.modalData.title },
    }),
    showToast: (
      state,
      action: {
        payload: {
          text: string;
          kind?: AlertProps['severity'];
          autoHide?: boolean;
        };
      },
    ) => ({
      ...state,
      toastData: { ...action.payload, open: true },
    }),
    hideToast: (state) => ({
      ...state,
      toastData: { ...state.toastData, open: false },
    }),
    showLoading: (state) => ({
      ...state,
      loading: true,
    }),
    hideLoading: (state) => ({
      ...state,
      loading: false,
    }),

    resetNavigation: () => initialState,
  },
});

export const { pushNavigation, showModal, hideModal, showToast, hideToast, showLoading, hideLoading, resetNavigation } =
  navigationSlice.actions;

export default navigationSlice.reducer;
